module.exports = __webpack_public_path__ + "static/img/right-ruler.20ce2fe8.png";